import { schedulerPreferencesAtom } from '../atoms/schedulerPreferences'

export function getSchedulerPreferences() {
  return schedulerPreferencesAtom.preferences
}
